<div class="mx-auto max-w-(--breakpoint-2xl)">
  <div class="rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-gray-900">
    <div class="mb-6 flex items-start justify-between gap-4">
      <div>
        <h1 class="text-2xl font-semibold text-gray-900 dark:text-white">Feature toggles</h1>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Globally enable or disable in-flight features. Off hides the feature from every user; on makes it visible to everyone.
          Changes take effect on the next page load.
        </p>
      </div>
    </div>

    @if (loading) {
      <p class="py-12 text-center text-sm text-gray-500 dark:text-gray-400">Loading…</p>
    } @else if (rows.length === 0) {
      <div class="rounded-lg border border-dashed border-gray-300 px-6 py-12 text-center dark:border-gray-700">
        <p class="text-sm text-gray-500 dark:text-gray-400">
          No features registered yet. Engineers register toggles in <code class="font-mono">config/feature-toggles.php</code>.
        </p>
      </div>
    } @else {
      <ul class="divide-y divide-gray-200 dark:divide-gray-800">
        @for (row of rows; track row.toggle.key) {
          <li class="flex flex-col gap-3 py-5 sm:flex-row sm:items-start sm:justify-between sm:gap-6">
            <div class="min-w-0 flex-1">
              <div class="flex items-center gap-2">
                <h2 class="text-base font-medium text-gray-900 dark:text-white">{{ row.toggle.label }}</h2>
                <span class="font-mono text-xs text-gray-400 dark:text-gray-500">{{ row.toggle.key }}</span>
              </div>
              @if (row.toggle.description) {
                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ row.toggle.description }}</p>
              }
              <p class="mt-2 text-xs text-gray-400 dark:text-gray-500">
                Last changed: {{ formatTimestamp(row.toggle.last_changed_at) }}
                @if (row.toggle.last_changed_by) {
                  by {{ row.toggle.last_changed_by.name }}
                }
              </p>
            </div>
            <div class="flex shrink-0 items-center gap-3">
              @if (row.saving) {
                <span class="text-xs text-gray-400">Saving…</span>
              }
              <app-checkbox
                [control]="row.control"
                [label]="row.control.value ? 'On' : 'Off'"
                [inline]="true"
              ></app-checkbox>
            </div>
          </li>
        }
      </ul>
    }
  </div>
</div>
